// extracted by mini-css-extract-plugin
export default {"delimiter":"Delimiter_delimiter__m7uXz","fade":"Delimiter_fade__pmcXo","block":"Delimiter_block__eOnXj"};